import React from "react";
import { store } from "../globalState/StateProvider";
import { Popover, Button } from "@material-ui/core";
import { SubscriptionDisplayCard } from "./SubscriptionDisplayCard";
import { getSubscriptionDetails } from "../services/api/subscription.api";
import { Fetcher } from "./Fetcher";
import { SubscriptionDetails } from "../models/Subscription";

interface SubscriptionBreadCrumbDisplayProps {
	productId: string;
	subscriptionId: string;
}

const subscriptionDisplay = (subscription: SubscriptionDetails, productId: string, anchor, setAnchorEl) => {
	const subSummary = {
		subscriptionId: subscription.subscription!.subscriptionId,
		productLicenseKey: subscription.subscription!.productLicenseKey,
		createdDate: subscription.subscription!.createdDate,
		productName: subscription.product!.productName,
		productTierName: subscription.productTier!.productTierName,
		companyName: subscription.company!.companyName,
		customerKeyDescription: subscription.subscription!.customerKeyDescription,
		isValidLicense: subscription.subscription!.isValidLicense,
	};
	const open = Boolean(anchor);
	const id = open ? "date-popover" : undefined;

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl({ x: event.clientX, y: event.clientY + 10 });
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<span>
			<Button size="small" variant="outlined" onClick={handleClick}>
				<div>{subscription.company!.companyName}</div>
			</Button>
			{anchor && (
				<Popover
					id={id}
					open={open}
					anchorReference="anchorPosition"
					anchorPosition={{ top: anchor.y, left: anchor.x }}
					onClose={handleClose}
					anchorOrigin={{
						vertical: "top",
						horizontal: "left",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "left",
					}}
				>
					<div style={{ padding: "6px 12px 12px 12px" }}>
						<SubscriptionDisplayCard subscription={subSummary} productId={productId}></SubscriptionDisplayCard>
					</div>
				</Popover>
			)}
		</span>
	);
};

/**
 * This component takes in the productId and the subscriptionId.
 * if the subscription is already saved in state we will use information from that however if it is not we will
 * use the fetcher to call it when the card is displayed and it will then set the subscription info in state.
 */
export const SubscriptionBreadCrumbDisplay = (props: SubscriptionBreadCrumbDisplayProps) => {
	const { subscription, setSubscription } = React.useContext(store);
	const [anchorEl, setAnchorEl] = React.useState(null);

	return (
		<span>
			<Fetcher
				loadedData={() =>
					subscription && subscription.subscription!.subscriptionId === props.subscriptionId ? subscription : null
				}
				action={getSubscriptionDetails(props.productId, props.subscriptionId)}
				placeHolder={() => <span>{props.subscriptionId}</span>}
				setStateData={setSubscription}
			>
				{(response) => subscriptionDisplay(response && response.data, props.productId, anchorEl, setAnchorEl)}
			</Fetcher>
		</span>
	);
};
